import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import { LotterySessionDto } from "../../models/Lottery";
import {
  CardGiftcard as CardGiftcardIcon,
  Person as PersonIcon,
  Casino as CasinoIcon,
  CheckCircle as CheckCircleIcon,
  PendingActions as PendingIcon,
} from "@mui/icons-material";

interface IRunLotteryDetailsProps {
  selectedLotteryId: string;
  selectedLottery: LotterySessionDto;
  lotteries: LotterySessionDto[];
  setSelectedLotteryId: (id: string) => void;
}

export const RunLotteryDetails = ({
  selectedLotteryId,
  lotteries,
  selectedLottery,
  setSelectedLotteryId,
}: IRunLotteryDetailsProps) => {
  return (
    <Paper
      sx={{
        p: 4,
        borderRadius: 4,
      }}
    >
      <FormControl fullWidth sx={{ mb: 1 }}>
        <InputLabel sx={{ "&.Mui-focused": { color: "hsl(350, 80%, 40%)" } }}>
          Επιλογή Λοταρίας
        </InputLabel>
        <Select
          value={selectedLotteryId}
          label="Επιλογή Λοταρίας"
          onChange={(e) => {
            setSelectedLotteryId(e.target.value);
          }}
          sx={{
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "hsl(350, 80%, 40%)",
            },
          }}
        >
          {lotteries.map((lottery: LotterySessionDto) => (
            <MenuItem
              key={lottery.sessionId}
              value={lottery.sessionId as string}
            >
              {lottery.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {!selectedLotteryId && (
        <div style={{ textAlign: "justify", marginTop: 10 }}>
          <Typography variant="h6" sx={{ color: "hsl(150, 30%, 40%)" }}>
            <CasinoIcon sx={{ color: "hsl(150, 30%, 60%)" }} /> Επίλεξε μια
            λοταρία παραπάνω για να ξεκινήσεις την κλήρωση των νικητών
          </Typography>
        </div>
      )}
      {selectedLotteryId && (
        <>
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: '"Mountains of Christmas", cursive',
                color: "hsl(350, 80%, 40%)",
              }}
            >
              {selectedLottery.title}
            </Typography>
            <Typography align="justify" sx={{ color: "hsl(150, 20%, 35%)" }}>
              {selectedLottery.description}
            </Typography>
          </Box>
          <Stack spacing={2}>
            <Stack
              padding={2}
              direction={"row"}
              alignContent={"space-between"}
              borderRadius={2}
              spacing={1}
              sx={{
                bgcolor: "hsl(200, 40%, 95%)",
              }}
            >
              <PersonIcon
                sx={{ color: "hsl(200, 60%, 40%)", fontSize: 32, mb: 1 }}
              />
              <Typography variant="h6" sx={{ color: "hsl(200, 20%, 35%)" }}>
                {selectedLottery.totalTickets} Λαχνοί
              </Typography>
            </Stack>

            <Stack
              padding={2}
              direction={"row"}
              alignContent={"space-between"}
              borderRadius={2}
              spacing={1}
              sx={{
                bgcolor: "hsl(45, 60%, 95%)",
              }}
            >
              <CardGiftcardIcon
                sx={{ color: "hsl(45, 90%, 45%)", fontSize: 32, mb: 1 }}
              />

              <Typography variant="h6" sx={{ color: "hsl(45, 80%, 35%)" }}>
                {selectedLottery.totalPrizes} Δώρα
              </Typography>
            </Stack>

            <Stack
              padding={2}
              direction={"row"}
              alignContent={"space-between"}
              borderRadius={2}
              spacing={1}
              sx={{
                bgcolor: "#d1ffd1",
              }}
            >
              <CheckCircleIcon
                sx={{ color: "hsl(150, 60%, 40%)", fontSize: 32, mb: 1 }}
              />
              <Typography variant="h6" sx={{ color: "hsl(150, 60%, 35%)" }}>
                {selectedLottery.drawnPrizesCount ?? 0} Εχουν κληρωθεί
              </Typography>
            </Stack>

            <Stack
              padding={2}
              direction={"row"}
              alignContent={"space-between"}
              borderRadius={2}
              spacing={1}
              sx={{
                bgcolor: "hsl(30, 60%, 95%)",
              }}
            >
              <PendingIcon
                sx={{ color: "hsl(30, 80%, 45%)", fontSize: 32, mb: 1 }}
              />
              <Typography variant="h6" sx={{ color: "hsl(30, 80%, 35%)" }}>
                {selectedLottery.totalPrizes -
                  (selectedLottery.drawnPrizesCount ?? 0)}{" "}
                Απομένουν
              </Typography>
            </Stack>
          </Stack>
        </>
      )}
    </Paper>
  );
};
